import InputIcon from "@mui/icons-material/Input";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { handleLoginAction } from "../../../redux/actoin";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import { persianToEnglish, toEnglish } from "../../../scripts/functions";
import HeaderReq from "../../../scripts/functions/headerReq";
import { useCountdown } from "../../../scripts/hooks/userCountdown";

function Otp({ handleBack }) {
  const [data, setData] = useState({ chOTPTypeCode: "PreLoginByOTPForTaxApp" });
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const navigate = useNavigate();
  const [err, setError] = useState("");
  const [step, setStep] = useState(1);
  const { minutes, seconds, reset } = useCountdown(120);
  const isMd = useMediaQuery("(min-width:900px)");
  const dispatch = useDispatch();
  const otpGenrator = () => {
    setLoading(true);
    setData({ ...data, chOTP: "" });
    axiosInstance
      .post(
        API.auth.genrateOtp,
        {
          ...data,
        },
        HeaderReq()
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          setStep(2);
          reset();
        } else {
          toast.error(res?.data?.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoading(false);
      });
  };
  const checkOtp = () => {
    setLoading2(true);
    axiosInstance
      .post(
        API.auth.loginOtp,
        {
          ...data,
        },
        HeaderReq()
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          if (res?.data?.data?.chToken) {
            navigate("/");
            dispatch(
              handleLoginAction({
                userName: res?.data?.data?.chUserTitle,
                token: res?.data?.data?.chToken,
              })
            );
          }
        } else {
          setData({ ...data, chOTP: "" });
          toast.error(res?.data?.message);
        }
        setLoading2(false);
      })
      .catch((err) => {
        setData({ ...data, chOTP: "" });

        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoading2(false);
      });
  };
  useEffect(() => {
    if (data?.chOTP?.length === 5) {
      checkOtp();
    }
  }, [data?.chOTP]);
  return (
    <div className="px-4 errorInput">
      {step === 1 ? (
        <>
          <Box
            component={"form"}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: "12px",
              height: "100%",
              gap: 2,
              borderRadius: { md: "4px 0px 0px 4px", xs: "0px 0px 4px 4px" },
              mt: 3,
            }}
          >
            <div className="flex w-full bg-white rounded-md gap-2 items-center pr-2 pl-1">
              <small className="min-w-max"> تلفن همراه </small>
              <TextField
                id="outlined-basic"
                variant="outlined"
                fullWidth
                type="tel"
                name="user_name"
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*?)\..*/g, "$1");
                }}
                error={err}
                helperText={err}
                onChange={(e) => {
                  if (e.target.value.length < 12) {
                    setData({
                      ...data,
                      chMobile: persianToEnglish(e.target.value),
                    });
                    if (e.target.value.length < 10) {
                      setError("تلفن همراه   معتبر نمی باشد");
                    } else {
                      setError("");
                    }
                  }
                }}
                value={data?.chMobile || ""}
                inputProps={{ maxLength: 11 }}
              />
            </div>
          </Box>
          <Box
            component={"div"}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              px: "12px",
              mt: 2,
              gap: 1,
            }}
          >
            <Button
              variant="contained"
              disabled={!data?.chMobile || loading}
              sx={{
                fontSize: "1rem",
                backgroundColor: "#0091ea",
                width: "150px !important",
              }}
              onClick={otpGenrator}
            >
              {loading ? (
                <>
                  {" "}
                  <CircularProgress size={27} />
                </>
              ) : (
                <> ارسال کد</>
              )}
            </Button>{" "}
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              px: "15px",
              fontSize: "1.25rem",
              mt: "19.5px",
              fontWeight: "bold",
              textAlign: "center",
            }}
            className="text-white"
          >
            ورود با رمز عبور یک بار مصرف
          </Box>
          <Box
            component={"form"}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: "12px",
              height: "100%",
              gap: 1,
              borderRadius: { md: "4px 0px 0px 4px", xs: "0px 0px 4px 4px" },
            }}
          >
            <h3 className="font-light text-white text-lg mb-5">
              {" "}
              کد ارسالی را وارد کنید
            </h3>
            <div className="w-full border text-white border-purple-100 rounded-sm py-4 flex flex-col justify-center items-center gap-3">
              <span>
                کد تاییدی به شماره <strong>{data?.chMobile}</strong> ارسال شد.
              </span>
              <Button
                onClick={() => {
                  setStep(1);
                  setData({ ...data, chOTP: "" });
                }}
                sx={{ color: "#fff", border: "1px solid #fff" }}
              >
                تغیر شماره موبایل
              </Button>
            </div>
            <OtpInput
              isDisabled={minutes === 0 && seconds === 0}
              separator={<span></span>}
              value={data?.chOTP | ""}
              onChange={(code) => setData({ ...data, chOTP: toEnglish(code) })}
              numInputs={5}
              shouldAutoFocus
              isInputNum={true}
              inputStyle={{
                width: isMd ? "2rem" : "1.2rem",
                height: isMd ? "2rem" : "1.2rem",
                margin: " 1rem",
                fontSize: isMd ? "2rem" : "1.3rem",
                borderBottom: "1px solid #fff",
                direction: "rtl !important",
                float: "right !important",
                outline: "none",
                fontFamily: "IRANYekanX !important",
                backgroundColor: "transparent",
                color: "#fff",
              }}
              containerStyle={{
                flexDirection: "row-reverse",
              }}
            />
            <div className="flex items-center justify-between gap-4  px-2 sm:px-8">
              {Number(minutes) > 0 || Number(seconds) > 0 ? (
                <>
                  {" "}
                  <span className="text-xs sm:text-sm text-white">
                    {" "}
                    زمان باقی مانده تا ارسال مجدد رمز :{" "}
                  </span>
                  <span className="text-xs sm:text-sm text-white">
                    {`${minutes}`}:{`${seconds}`}
                  </span>
                </>
              ) : (
                <>
                  <span className="text-xs text-white">
                    کد را دریافت نکرده اید؟{" "}
                  </span>
                  <Button
                    variant="outlined"
                    className=" text-white disabled:text-gray-400 disabled:cursor-not-allowed"
                    size="small"
                    sx={{
                      fontSize: " 0.75rem !important",
                      color: "#fff !important",
                      border: "1px solid #fff",
                    }}
                    onClick={() => otpGenrator()}
                    type="button"
                  >
                    دریافت مجدد کد{" "}
                  </Button>
                </>
              )}
            </div>
          </Box>
          <Box
            component={"div"}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: "12px",
              mt: 20,
              gap: 4,
            }}
          >
            <Button
              variant="contained"
              disabled={!data?.chOTP || loading2}
              sx={{
                fontSize: "1rem",
                backgroundColor: "#0091ea",
                width: "150px !important",
              }}
              onClick={checkOtp}
            >
              {loading2 ? (
                <>
                  {" "}
                  <CircularProgress size={27} />
                </>
              ) : (
                <> ورود</>
              )}
            </Button>
            <Button
              variant="outlined"
              sx={{
                fontSize: "1rem",
                color: { md: "#fff !important" },
                borderColor: { md: "#fff !important" },
                width: "150px !important",
              }}
              onClick={() => {
                setStep(1);
                setData({ ...data, chOTP: "" });
              }}
            >
              <InputIcon sx={{ width: "18px", height: "18px", mr: "5px" }} />
              بازگشت
            </Button>
          </Box>
        </>
      )}
    </div>
  );
}

export default Otp;
